import Hero from "./Hero";
import ServicesDiagonal from "./ServicesDiagonal";

function Services() {
  return (
    <div>
      <Hero />
      <ServicesDiagonal />
    </div>
  );
}

export default Services;
